import { Reducer } from "@reduxjs/toolkit";
import { StationLastVisits } from "./queryStationStatus";
import { createAsyncEntitySlice } from "../../../Store/Entities/createAsyncEntitySlice";
import { AsyncEntityState, createForeignKeySelector } from "../../../Store/Thunks/asyncEntityStateUtil";
import { RootState } from "../../../Store";
import { EnqueueFetcher } from "../../../Store/Thunks/enqueueFetcher";
import { fetchStationVisitsByStationIdsThunk } from "../../../Store/Thunks/stationStatusByIds";
import { entityByIdWithStatusHookFactory } from "../../../Store/Entities/entityByIdWithStatusHookFactory";

// Explicit typing is required
const {reducer, actions, entityAdapter, getSelectors}  = createAsyncEntitySlice({
  name: "stationVisits",
  reducers: {
    },
  fetchByIdsThunk: fetchStationVisitsByStationIdsThunk,
  selectId:(stationLastVisits) => stationLastVisits.stationId
})

export const stationVisitsReducer = reducer as Reducer<AsyncEntityState<StationLastVisits, number>>;

const selectState = (state: RootState) => state.graphQlData.stationVisits;

const {addOne, addMany, upsertOne, upsertMany, removeAll, removeOne, clearPendingIds, addPendingId, addLoadingIds} = actions;
export const {selectById: selectStationVisitsById, selectAll: SelectAllStationVisits} = entityAdapter.getSelectors(selectState);

const stationVisitsByIdFetcher = new EnqueueFetcher(fetchStationVisitsByStationIdsThunk, selectState, clearPendingIds, addPendingId, addLoadingIds)

export const upsertStationVisits = upsertMany;

export const dispatchFetchStationVisitsById = stationVisitsByIdFetcher.enqueueFetchById;

export const {selectEntitiesByForeignKey: selectStationVisitsByStationId} = createForeignKeySelector<StationLastVisits, number, AsyncEntityState<StationLastVisits, number>, number>((state) => state.graphQlData?.stationVisits, "stationId");
const selectLoadingIds = getSelectors(selectState).selectLoadingIds;

export const useStationVisitsById = entityByIdWithStatusHookFactory<StationLastVisits, number>(stationVisitsByIdFetcher.enqueueFetchById, selectStationVisitsById, selectLoadingIds )
